import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import formatDate from "../../common/Formatdate";
import formatDateAndTime from "../../common/formatDateAndTime";
import getactions from "../../common/getactions";
import moment from "moment";

function createData(AgentId, Name, Email, CreatedOn) {
  return {
    AgentId,
    Name,
    Email,
    CreatedOn,
  };
}

const Assignsalesagent = ({
  summaryDetails,
  getBookingDetail,
  selectedRow,
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const profile = JSON.parse(localStorage.getItem("profile"));
  let token = localStorage.getItem("token");
  const [usersList, setUsersList] = useState([]);
  const actionsToAccess = getactions(profile?.roles, profile?.actions);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [agentHistory, setAgentHistory] = useState([]);

  const rows = agentHistory?.map((item) =>
    createData(
      item?.agentId || "-",
      item?.agentName,
      item?.agentEmail,
      formatDateAndTime(item?.createdAt) || "-",
    ),
  );

  useEffect(() => {
    if (
      summaryDetails?.salesAgentAssingedHistories ||
      summaryDetails?.salesAgentAssingedHistory
    ) {
      if (
        summaryDetails?.salesAgentAssingedHistories?.length > 1 ||
        summaryDetails?.salesAgentAssingedHistory?.length > 1
      ) {
        setAgentHistory(
          summaryDetails?.salesAgentAssingedHistories
            ? summaryDetails?.salesAgentAssingedHistories
            : summaryDetails?.salesAgentAssingedHistory,
        );
      } else {
        setAgentHistory(
          summaryDetails?.salesAgentAssingedHistories
            ? [summaryDetails?.salesAgentAssingedHistories]
            : [summaryDetails?.salesAgentAssingedHistory],
        );
      }
    }
  }, [summaryDetails]);

  const getUsersList = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/users?limit=100&isSalesAgent=true`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setUsersList(data?.entities?.rows);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Users List:", error);
    }
  };

  useEffect(() => {
    getUsersList();
  }, []);

  const getAssignAgentList = async (type) => {
    let payload;

    if (type === "me") {
      payload = {
        bookingId: summaryDetails?.id,
        agentId: profile && profile?.id,
        agentName: profile && profile?.name,
        agentEmail: profile && profile?.email,
        assginedBy: profile && profile?.id,
      };
    } else {
      payload = {
        bookingId: summaryDetails?.id,
        agentId: selectedAgent?.id,
        agentName: selectedAgent?.name,
        agentEmail: selectedAgent?.email,
        assginedBy: profile?.id,
      };
    }
    try {
      const response = await fetch(
        `${apiUrl}/api/salesagentassingedhistories`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify(payload),
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        await getBookingDetail(selectedRow?.inquiryID);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Users List:", error);
    }
  };

  const handleAssign = async (type) => {
    let payload;

    if (type === "me") {
      payload = {
        id: summaryDetails?.id,
        assignedAgent: profile && profile?.id,
        isSalesAgentAssigned: true,
        inquiryAssignedOn: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      };
    } else {
      payload = {
        id: summaryDetails?.id,
        assignedAgent: selectedAgent?.id,
        isSalesAgentAssigned: true,
        inquiryAssignedOn: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      };
    }

    try {
      const response = await fetch(`${apiUrl}/api/vehiclebookings`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        await getAssignAgentList(type);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Users List:", error);
    }
  };

  return (
    <div>
      <div className="md:p-6">
        <div className="overflow-hidden rounded-lg shadow mb-8">
          <div className="w-full text-left bg-white">
            <div className="bg-[#34495e] text-white">
              <h1 className="px-6 py-4 text-left" colSpan={2}>
                Assign Sales Agent
              </h1>
            </div>
            <div className="flex items-center gap-4 px-6 py-6">
              {actionsToAccess?.includes("Assign Sales Agent") && (
                <div className="flex flex-row gap-4">
                  <select
                    id="deliveryagent"
                    required
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      const selectedUser = usersList.find(
                        (user) => String(user.id) === selectedId,
                      );
                      if (selectedUser) {
                        setSelectedAgent({
                          id: selectedUser.id,
                          name: selectedUser.name,
                          email: selectedUser.email,
                          mobile: selectedUser?.mobile,
                        });
                      }
                    }}
                    className="w-80 border-2 border-gray-200 rounded-lg p-3 focus:ring focus:ring-blue-100"
                  >
                    <option value="">Select Sales Agent</option>
                    {usersList?.map((item, index) => {
                      return (
                        <option
                          className="text-black"
                          key={index}
                          name={item?.name}
                          value={item?.id}
                        >
                          {item?.name +
                            " - " +
                            item?.email +
                            " - " +
                            item?.mobile}
                        </option>
                      );
                    })}
                  </select>
                  <button
                    onClick={() => {
                      handleAssign("others");
                    }}
                    className="px-[30px] py-[12.5px] bg-[#2ba8fb] text-white font-bold rounded-full transition-all duration-500 hover:bg-[#6fc5ff] hover:shadow-[0_0_20px_rgba(111,197,255,0.31)] hover:scale-110 active:bg-[#3d94cf] active:scale-95 active:shadow-none"
                  >
                    Assign
                  </button>
                </div>
              )}
              <button
                onClick={() => {
                  handleAssign("me");
                }}
                className="px-[30px] py-[12.5px] bg-[#164a01] text-white font-bold rounded-full transition-all duration-500 hover:bg-[#164a01] hover:shadow-[0_0_20px_rgba(111,197,255,0.31)] hover:scale-110 active:bg-[#3d94cf] active:scale-95 active:shadow-none"
              >
                Assign to Me
              </button>
            </div>

            {agentHistory?.length > 0 && (
              <div className="md:col-span-3 bg-white border rounded-xl shadow-md p-6">
                <TableContainer component={Paper}>
                  <Table
                    sx={{ minWidth: 650 }}
                    size="small"
                    aria-label="dynamic table"
                  >
                    <TableHead>
                      <TableRow className="bg-gray-100">
                        {rows.length > 0 &&
                          Object.keys(rows[0]).map((key) => (
                            <TableCell key={key}>{key}</TableCell>
                          ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.map((row, index) => (
                        <TableRow key={index}>
                          {Object.entries(row).map(([key, value], idx) => (
                            <TableCell key={idx}>
                              {key === "attachments" && value ? (
                                <div
                                  title="image"
                                  className="flex gap-4 items-center cursor-pointer"
                                >
                                  {value.map((item, index) => (
                                    <div
                                      key={index}
                                      className="items-center gap-2"
                                    >
                                      <img
                                        src={item?.url}
                                        alt="Attachment"
                                        className="w-8 h-8 object-contain"
                                      />
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                value
                              )}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Assignsalesagent;
